<!-- Must use "EditBox" mixin in parent component, which will import the required component, computed properties, methods and data needed.
-->
<template>
  <div class="edit-box" v-on-clickaway="closeBox">
    <div class="edit-box__fields">
      <AppTextArea
        v-model="editedValue"
        v-bind="$attrs"
        v-on="$listeners"
        class="edit-box__field"
        auto-height
        @keydown.enter="!lineBreak && editionDone($event)"
        @keydown.escape="closeBox"
      />
      <!-- extra element -->
      <slot />
    </div>
    <div class="edit-box__controls">
      <AppButton primary @click="editionDone">{{ saveButtonText }}</AppButton>
      <AppButtonIcon @click="closeBox(null, true)" icon="fal fa-times" />
    </div>
  </div>
</template>

<script>
// Utilities
import { missClicked } from 'Utils'
import { mixin as clickaway } from 'vue-clickaway'
// Components
import AppButton from 'Ui/AppButton'
import AppTextArea from 'Ui/AppTextArea'
import AppButtonIcon from 'Ui/AppButtonIcon'

export default {
  name: 'EditBox',

  components: {
    AppButton,
    AppTextArea,
    AppButtonIcon,
  },

  props: {
    value: {
      type: String,
      default: '',
    },

    lineBreak: {
      type: Boolean,
      default: false,
    },

    reset: {
      type: Boolean,
      default: false,
    },

    saveButtonText: {
      type: String,
      default: 'Guardar',
    },
  },

  mixins: [clickaway],

  data() {
    return {
      editedValue: this.value,
    }
  },

  methods: {
    editionDone($event) {
      $event.preventDefault()
      this.$emit('edition-done', this.editedValue)
      if (!this.reset) return
      this.editedValue = ''
    },

    updated() {
      this.$emit('input', this.editedValue)
    },

    closeBox(event, bypass = false) {
      if (missClicked() && !bypass) return
      this.$emit('close-box')
    },
  },
  // watch: {
  //   value(newValue) {
  //     this.editedValue = newValue
  //   },
  // },
  mounted() {
    this.$el && this.$el.nodeName !== '#comment' && this.$el.querySelector('.app-textarea').focus()
  },
}
</script>

<style scoped>
.edit-box {
  width: 100%;
  outline: none;
  /* padding: 10px; */
  border-radius: 4px;
  /* background: var(--c-secondary-300); */
  margin-bottom: 10px;
}

.edit-box__controls {
  display: grid;
  grid-template-columns: auto auto;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin-top: 10px;
}

.edit-box__controls >>> .app-button {
  font-size: 12px;
  line-height: 18px;
  width: auto;
  height: unset;
  min-height: unset;
  padding: 6px 12px;
  transition: none;
}
</style>

<style src="@/assets/css/shared-styles/editBox.css" scoped></style>
